import { acceptHMRUpdate, defineStore } from 'pinia'
import categoryService from '@/services/category.service'

export const useCategoryStore = defineStore({
  id: 'categoryStore',
  state: () => ({
    categories: [],
    selectedCategoryIds: []
  }),
  setup () {},
  actions: {
    getCategoryList () {
      return categoryService.getCategoryList().then(
        response => {
          this.categories = response.data.data.categories
          return response
        }
      )
    },
    setSelectedCategoryIds () {
      const formData = {
        ids: this.selectedCategoryIds.join(',')
      }

      return categoryService.setSelectedCategoryIds(formData).then(
        response => {
          return response
        }
      )
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCategoryStore, import.meta.hot))
}
